import React from 'react';
import { FormGroup as FG } from 'reactstrap';

export default function FormGroup({ children, className }) {
  return (
    <FG className={`form-group has-float-label ${className}`}>{children}</FG>
  );
}
